import Content from '@/layout/content';
import Layout from '@/layout';

export default {
  path: '/musicbox',
  component: window.name ? Content : Layout,
  meta: {
    title: '首页',
    icon: 'iconfont icon-home',
    code: '01020101'
  },
  children: [
    {
      path: '',
      name: 'musicbox',
      component: () => import('@/views/musicbox'),
      meta: {
        activeMenu: '/musicbox'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
